var render = function () {
var _obj, _obj$1, _obj$2;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"card-loader"}},[_c('div',{staticClass:"card",class:( _obj = {}, _obj[_vm.size] = true, _obj )}),_c('div',{staticClass:"card",class:( _obj$1 = {}, _obj$1[_vm.size] = true, _obj$1 )}),_c('div',{staticClass:"card",class:( _obj$2 = {}, _obj$2[_vm.size] = true, _obj$2 )})])}
var staticRenderFns = []

export { render, staticRenderFns }